import { PrescriptionFeedback } from "@/domain/entities/PrescriptionFeedback";
import { PrescriptionFeedbackResponseDataDTO } from "../dto/PrescriptionFeedbackResponseDTO";
import { EDocumentType } from "@/domain/enums";

const toEntity = (data: PrescriptionFeedbackResponseDataDTO): PrescriptionFeedback => {
    let document_type = EDocumentType.MEDICAL_RECORD
    if (data.action === 'recipe') {
        document_type = EDocumentType.PRESCRIPTION
    }
    return {
        id: `${data?.id || ""}`,
        user: {
            id: data?.user?.id || "",
            name: data?.user?.name || "",
            email: data?.user?.email || "",
        },
        document_type,
        document_id: data?.action_id || "",
        had_problem: !!data?.had_problem,
        problem_description: data?.problem_description || "",
        suggestion: data?.suggestion || "",
        created_at: data?.created_at || "1992-04-23 23:30:00",
    }
}

export default {
    toEntity
}